import BreadcrumbTitle from "components/BreadcrumbTitle"
import PageMetaTags from "components/PageMetaTags"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Col,
  Container,
  Nav,
  Row,
  TabContent,
  TabPane,
  NavLink,
  Card,
  CardBody,
  Modal,
  Spinner,
} from "reactstrap"
import { FormSection, getFormValues, initialize, reduxForm } from "redux-form"
import { getLandingSetup, updateLandingSetup } from "store/actions"
import { getFileBlob } from "utils"
import BackgroundTab from "./backgroundTab"
import ButtonTab from "./buttonTab"
import HeaderTab from "./headerTab"
import LayoutTab from "./layoutTab"
import MenuTab from "./menuTab"
import { mapApiResponseToForm, mapFormToApi } from "./utils"

const LandingScreen = ({
  getLandingSetup,
  vendorId,
  landingSetup,
  initializeForm,
  loading,
  formValues,
  updateLandingSetup,
  userId,
}) => {
  const TABS = {
    LAYOUT: 1,
    BACKGROUND: 2,
    HEADER: 3,
    BUTTON: 4,
    MENU: 5,
  }

  useEffect(() => {
    if (vendorId) {
      getLandingSetup({ vendorId: vendorId })
    }
  }, [vendorId])

  useEffect(() => {
    if (landingSetup) {
      initializeForm(mapApiResponseToForm(landingSetup))
    }
  }, [landingSetup])

  const [activeTab, setActiveTab] = useState(TABS.LAYOUT)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  const [breadcrumbItems, setBreadcrumbItems] = useState([])

  useEffect(() => {
    if (activeTab !== 5) {
      let array = [
        { title: "Dashboard" },
        {
          title: "Landing Screen",
          type: "tab",
          clickHandler: () => setActiveTab(TABS.LAYOUT),
        },
      ]
      switch (activeTab) {
        case 1:
          array.push({ title: "Layout" })
          break
        case 2:
          array.push({ title: "Background" })
          break
        case 3:
          array.push({ title: "Header" })
          break
        case 4:
          array.push({ title: "Button" })
          break
        default:
          break
      }
      setBreadcrumbItems(array)
    }
  }, [activeTab])

  const setSubTabBreadcrumb = (tabTitle, clickHandler) => {
    setBreadcrumbItems([
      { title: "Dashboard" },
      {
        title: "Landing Screen",
        type: "tab",
        clickHandler: () => setActiveTab(TABS.LAYOUT),
      },
      {
        title: "Menu",
        type: "tab",
        clickHandler: clickHandler,
      },
      { title: tabTitle },
    ])
  }

  const handleSave = () => {
    updateLandingSetup({
      values: { ...landingSetup, ...mapFormToApi(formValues) },
      uploadLogoImage:
        formValues?.header?.deleteLogo &&
        formValues?.header?.logoImage?.editedImage
          ? true
          : false,
      logoImage: {
        vendor_id: vendorId,
        dir: "background",
        user_id: userId,
        files: [
          getFileBlob(
            formValues?.header &&
              formValues?.header?.logoImage &&
              formValues?.header?.logoImage?.editedImage
          ),
        ],
      },
      uploadBackgroundImage:
        formValues?.background?.deleteBackground &&
        formValues?.background?.bgImage?.editedImage
          ? true
          : false,
      bgImage: {
        vendor_id: vendorId,
        dir: "background",
        user_id: userId,
        files: [
          getFileBlob(
            formValues?.background &&
              formValues?.background?.bgImage &&
              formValues?.background?.bgImage?.editedImage
          ),
        ],
      },
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Landing Screen" />
        <Container fluid>
          <BreadcrumbTitle
            title="Landing Screen"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Nav pills tabs>
                    <NavLink
                      className={markIfIsActive(TABS.LAYOUT)}
                      onClick={() => setActiveTab(TABS.LAYOUT)}
                    >
                      {<span style={{ fontSize: "16px" }}>Layout</span>}
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.BACKGROUND)}
                      onClick={() => setActiveTab(TABS.BACKGROUND)}
                    >
                      {<span style={{ fontSize: "16px" }}>Background</span>}
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.HEADER)}
                      onClick={() => setActiveTab(TABS.HEADER)}
                    >
                      {<span style={{ fontSize: "16px" }}>Header</span>}
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.BUTTON)}
                      onClick={() => setActiveTab(TABS.BUTTON)}
                    >
                      {<span style={{ fontSize: "16px" }}>Button</span>}
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.MENU)}
                      onClick={() => setActiveTab(TABS.MENU)}
                    >
                      {<span style={{ fontSize: "16px" }}>Menu</span>}
                    </NavLink>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={TABS.LAYOUT}>
                      <FormSection name="layout">
                        <LayoutTab
                          handleSave={handleSave}
                          handleNext={() => {
                            setActiveTab(TABS.BACKGROUND)
                          }}
                          tabIsActive={activeTab === TABS.LAYOUT}
                        />
                      </FormSection>
                    </TabPane>
                    <TabPane tabId={TABS.BACKGROUND}>
                      <FormSection name="background">
                        <BackgroundTab
                          handleSave={handleSave}
                          handleNext={() => {
                            setActiveTab(TABS.HEADER)
                          }}
                          handleBack={() => {
                            setActiveTab(TABS.LAYOUT)
                          }}
                          tabIsActive={activeTab === TABS.BACKGROUND}
                        />
                      </FormSection>
                    </TabPane>
                    <TabPane tabId={TABS.HEADER}>
                      <FormSection name="header">
                        <HeaderTab
                          handleSave={handleSave}
                          handleNext={() => {
                            setActiveTab(TABS.BUTTON)
                          }}
                          handleBack={() => {
                            setActiveTab(TABS.BACKGROUND)
                          }}
                          tabIsActive={activeTab === TABS.HEADER}
                        />
                      </FormSection>
                    </TabPane>
                    <TabPane tabId={TABS.BUTTON}>
                      <FormSection name="button">
                        <ButtonTab
                          handleSave={handleSave}
                          handleNext={() => {
                            setActiveTab(TABS.MENU)
                          }}
                          handleBack={() => {
                            setActiveTab(TABS.HEADER)
                          }}
                          tabIsActive={activeTab === TABS.BUTTON}
                        />
                      </FormSection>
                    </TabPane>
                    <TabPane tabId={TABS.MENU}>
                      <FormSection name="menu">
                        <MenuTab
                          handleSave={handleSave}
                          handleBack={() => {
                            setActiveTab(TABS.BUTTON)
                          }}
                          tabIsActive={activeTab === TABS.MENU}
                          setSubTabBreadcrumb={setSubTabBreadcrumb}
                        />
                      </FormSection>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={loading} centered={true} size="sm">
        <CardBody className={"p-2 my-1 text-center"}>
          <Spinner className="ms-2" color="primary" />
        </CardBody>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  formValues: getFormValues(FORM_NAMES.LANDING_SCREEN)(state),
  vendorId: state.Login.vendorId,
  landingSetup: state.LandingScreen.landingSetup,
  loading: state.LandingScreen.loading,
  userId: state.Login.authUser.id,
})

const mapDispatchToProps = dispatch => ({
  getLandingSetup: values => dispatch(getLandingSetup(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.LANDING_SCREEN, values)),
  updateLandingSetup: values => dispatch(updateLandingSetup(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: FORM_NAMES.LANDING_SCREEN,
  })(LandingScreen)
)
